import { Link } from 'react-router-dom';
import { latestNews } from '@/mocks/news';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

const categoryColor: Record<string, string> = {
  产品进展: 'text-accent-600',
  行业洞察: 'text-primary-600',
  合作实践: 'text-secondary-600',
};

export default function LatestUpdates() {
  const [featured, ...rest] = latestNews;

  return (
    <section id="latest-updates" className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            title="资讯中心"
            en="News Center"
            subtitle="记录产品进展、行业洞察与合作实践。所有内容按实际发布日期持续更新。"
          />
        </Reveal>

        {latestNews.length === 0 ? (
          <div className="mt-12 text-center py-16 text-foreground-500">
            <i className="ri-calendar-todo-line text-4xl"></i>
            <p className="mt-4 text-base">内容准备中，欢迎留下您的合作需求</p>
          </div>
        ) : (
          <div className="mt-12 md:mt-16 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
            {/* 左：大图焦点 */}
            <Reveal className="lg:col-span-7">
              <Link to="/news" className="group block cursor-pointer">
                <div className="relative w-full aspect-[16/10] overflow-hidden rounded-lg bg-background-200">
                  <img
                    src={featured.image}
                    alt={featured.title}
                    title={`华辉数智 ${featured.title}`}
                    className="w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                  />
                </div>
                <div className="mt-5">
                  <div className="flex items-center gap-3 text-xs md:text-sm flex-wrap">
                    <span className={`${categoryColor[featured.category]} font-medium whitespace-nowrap`}>
                      {featured.category}
                    </span>
                    <span className="font-mono tabular-nums text-foreground-500">{featured.date}</span>
                  </div>
                  <h3 className="mt-2.5 font-heading font-bold text-xl md:text-2xl text-foreground-950 leading-snug transition-colors duration-300 group-hover:text-primary-700">
                    {featured.title}
                  </h3>
                  <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed">
                    {featured.summary}
                  </p>
                  <div className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 transition-transform duration-300 group-hover:translate-x-0.5">
                    阅读详情
                    <i className="ri-arrow-right-line text-base"></i>
                  </div>
                </div>
              </Link>
            </Reveal>

            {/* 右：资讯列表 */}
            <div className="lg:col-span-5">
              <div className="flex flex-col border-t border-background-200">
                {rest.map((item, idx) => (
                  <Reveal key={item.id} delay={idx * 80}>
                    <Link
                      to="/news"
                      className="group flex flex-col gap-2 py-5 border-b border-background-200 cursor-pointer"
                    >
                      <div className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
                        <span className={`${categoryColor[item.category]} font-medium whitespace-nowrap`}>
                          {item.category}
                        </span>
                        <span className="font-mono tabular-nums">{item.date}</span>
                      </div>
                      <h4 className="text-sm md:text-[15px] font-medium text-foreground-900 leading-snug transition-colors duration-300 group-hover:text-primary-700">
                        {item.title}
                      </h4>
                    </Link>
                  </Reveal>
                ))}
              </div>

              <Link
                to="/news"
                className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer transition-colors"
              >
                查看更多资讯
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}